export const WELL_PROJECT_HISTORY_PAGE_LOADED =
  'WELL_PROJECT_HISTORY_PAGE_LOADED';
